// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messageBox {
  background: #F3F3F3;
  border-radius: 4px;
  padding: 5px 10px;
  color: white;
  display: inline-block;
  max-width: 70%;
}

.messageText {
  width: 100%;
  letter-spacing: 0;
  float: left;
  font-size: 13px;
  word-wrap: break-word;
  padding: 8px 8px 0px 8px !important;
}
.date1{
  color:green;
  font-size: 10px !important;
}
.date2{
  width:90%;
  color:azure;
  font-size: 10px !important;
}

.messageText img {
  vertical-align: middle;
}

.messageContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 3px;
}

.centerlines {
  margin-left: 110px !important;
}

.msgbox1 {
  border-radius: 4px;
  color: black;
  max-width: 80%;
}

.messageText2 {
  width: 100%;
  letter-spacing: 0;
  float: left;
  font-size: 13px;
  word-wrap: break-word;
}

.sentText {
  display: flex;
  align-items: center;
  font-family: Helvetica;
  color: #828282;
  letter-spacing: 0.3px;
}

.pl-10 {
  padding-left: 10px;
}

.pr-10 {
  padding-right: 10px;
}

.justifyStart {
  justify-content: flex-start;
}

.justifyEnd {
  justify-content: flex-end;
}

.colorWhite {
  color: #353535;
}

.colorDark {
  color: white;
}

.backgroundBlue {
  background: #F3F3F3;
}

.backgroundLight {
  background: #6C5B7B;
}`, "",{"version":3,"sources":["webpack://./src/pages/Chatbot_v2/components/Messages/Message/Message.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".messageBox {\n  background: #F3F3F3;\n  border-radius: 4px;\n  padding: 5px 10px;\n  color: white;\n  display: inline-block;\n  max-width: 70%;\n}\n\n.messageText {\n  width: 100%;\n  letter-spacing: 0;\n  float: left;\n  font-size: 13px;\n  word-wrap: break-word;\n  padding: 8px 8px 0px 8px !important;\n}\n.date1{\n  color:green;\n  font-size: 10px !important;\n}\n.date2{\n  width:90%;\n  color:azure;\n  font-size: 10px !important;\n}\n\n.messageText img {\n  vertical-align: middle;\n}\n\n.messageContainer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 3px;\n}\n\n.centerlines {\n  margin-left: 110px !important;\n}\n\n.msgbox1 {\n  border-radius: 4px;\n  color: black;\n  max-width: 80%;\n}\n\n.messageText2 {\n  width: 100%;\n  letter-spacing: 0;\n  float: left;\n  font-size: 13px;\n  word-wrap: break-word;\n}\n\n.sentText {\n  display: flex;\n  align-items: center;\n  font-family: Helvetica;\n  color: #828282;\n  letter-spacing: 0.3px;\n}\n\n.pl-10 {\n  padding-left: 10px;\n}\n\n.pr-10 {\n  padding-right: 10px;\n}\n\n.justifyStart {\n  justify-content: flex-start;\n}\n\n.justifyEnd {\n  justify-content: flex-end;\n}\n\n.colorWhite {\n  color: #353535;\n}\n\n.colorDark {\n  color: white;\n}\n\n.backgroundBlue {\n  background: #F3F3F3;\n}\n\n.backgroundLight {\n  background: #6C5B7B;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
